<template>
  <div class="monitorDialog">
    <el-dialog
      title="生成监测点"
      :visible.sync="status"
      width="30%"
      :close-on-click-modal="false"
    >
      <div class="dialog__main">
        <p><img src="../img/monitorIcon.png" />监测点</p>
        <div class="tree">
<!--          <p>删除设备会清空该设备的所有数据，确认删除？</p>-->
          <el-tree
            ref="cirtree"
            show-checkbox
            :data="cirTree"
            :props="defaultProps"
            node-key="id"
            default-expand-all
            @node-click="handleNodeClick"
          ></el-tree>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="status = false">取 消</el-button>
        <el-button type="primary" @click="status = false;uploadcir()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Axios from "@/utils/Axios";
export default {
  name: "monitorDialog",
  data() {
    return {
      data: [
        {
          id: 1,
          label: "一级 1",
          children: [
            {
              id: 4,
              label: "二级 1-1",
              children: [
                {
                  id: 9,
                  label: "三级 1-1-1",
                },
                {
                  id: 10,
                  label: "三级 1-1-2",
                },
              ],
            },
          ],
        },
      ],
      defaultProps: {
        children: 'branchList',
        label: 'label'
      },
      status: false,
      deletearr: [],
      cirTree: [],
    };
  },
  props: {
    //test:null,
    multipleSelection:{
      type: Array,//可以注明设置类型，
      default:'',//默认值,
      required:false,//是否必须
    }
  },
  methods: {
    checkAllChange() {
      let that=this
        this.$nextTick(() => {    //这个如果要默认全选就必须加，否则会报错“setCheckedNodes”未定义
          that.$refs.cirtree.setCheckedNodes(that.cirTree)
        })
    },
    uploadcir(){
      let arr=this.$refs.cirtree.getCheckedNodes()
      let branchIds=[]
      for(let i=0;i<arr.length;i++){
        if(arr[i].branchList){

        }else{
          branchIds.push(arr[i].id)
        }
      }
      this.sendcirbranids(branchIds)
    },
    sendcirbranids(branchIds){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/branch/batchAddBranchSite";
      param.data=
        {
          branchIds:branchIds
        }
      Axios.ajax(param).then((res)=>{


        if(res.resultCode=='0'){
          that.$message({
            type: 'success',
            message:"添加成功"
          });
          this.showcreate=false
          this.$emit("gettabledata", true)
        }else{
          that.$message({
            type: 'error',
            message: res.resultMessage
          });
        }
      })
    },
    createall(){

      let that = this;
      let param = {};
      let deletearr=this.duplicateRemoval(this.deletearr)

      param.method="post";
      param.url="/device/getTerminalBranchList";
      param.data=
        {
          terminalIds:deletearr
        }
      Axios.ajax(param).then((res)=>{

        if(res.data){
          that.showcreate=true
          for(let i=0;i<res.data.length;i++){
            res.data[i].label=res.data[i].terminalName
            res.data[i].id=res.data[i].terminalId
            for(let j=0;j<res.data[i].branchList.length;j++){
              res.data[i].branchList[j].label=res.data[i].branchList[j].branchName
              res.data[i].branchList[j].id=res.data[i].branchList[j].branchId
            }
          }

          that.cirTree=res.data
          that.checkAllChange()

        }

      })

    },
    controlDialog() {
      this.status = true;

      this.deletearr=[]
        console.log(this.multipleSelection)
      for(let i=0;i<this.multipleSelection.length;i++){
        if(this.multipleSelection[i].children.length){
          for(let j=0;j<this.multipleSelection[i].children.length;j++){
            this.deletearr.push(this.multipleSelection[i].children[j].terminalId)
          }
        }
        this.deletearr.push(this.multipleSelection[i].terminalId)
      }

      this.createall()
    },
    handleNodeClick(data) {

    },
    duplicateRemoval(arr) {
      //定义接收去重后结果的新数组
      let newArr = [];
      for(let i = 0;i<arr.length;i++){
        //判断新数组中是否存在当前索引为i的原数组元素
        if (!newArr.includes(arr[i])) {
          //如果不存在，则将其放到新数组的最后位置
          newArr.push(arr[i]);
        }
      }
      //返回去重后的新数组
      return newArr;
    }

  },
  mounted() {

  },
  watch:{
    multipleSelection(){
      this.deletearr=[]

      for(let i=0;i<this.multipleSelection.length;i++){
        if(this.multipleSelection[i].children && this.multipleSelection[i].children.length){
          for(let j=0;j<this.multipleSelection[i].children.length;j++){
            this.deletearr.push(this.multipleSelection[i].children[j].terminalId)
          }
        }
        this.deletearr.push(this.multipleSelection[i].terminalId)
      }

      this.createall()
    }
  }
};
</script>

<style lang="less" scoped>
.monitorDialog {
  .tree{
    height: 400px;
    overflow: auto;
  }
  .dialog__main {
    p {
      margin: 0 0 10px 0;
      height: 30px;
      line-height: 10px;
      img {
        margin-right: 12px;
      }
    }
  }
}
</style>
